import styled from "styled-components";

const InsideUsersStyled = styled.div`

`;

export default InsideUsersStyled;